import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'finalized', label: 'Finalized' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'user_name', label: 'Employee' },
  { key: 'type', label: 'Type' },
  { key: 'effective_date', label: 'Effective Date' },
  { key: 'final_pay_amount', label: 'Final Pay', align: 'right', type: 'money' },
  { key: 'status', label: 'Status' },
];

export function SeparationRegisterReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Separation Register"
      description="Every separation record with type, effective date and final pay."
      endpoint="/reports/hr/separation"
      columns={COLUMNS}
      filters={['status', 'category', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
      categoryOptions={listOptions(lists, 'separation_type')}
      listColumns={{ type: 'separation_type' }}
    />
  );
}
